export default __webpack_public_path__ + "static/media/paymentBlack.fc33e9e9.svg";